import "./EditCardRibbon.css";
import {faCancel} from "@fortawesome/free-solid-svg-icons/faCancel";
import {faFloppyDisk} from "@fortawesome/free-solid-svg-icons/faFloppyDisk";
import {faPencil} from "@fortawesome/free-solid-svg-icons/faPencil";
import FontAwesomeButton from "./cards/FontAwesomeButton";
import {FontAwesomeButtonEnumTypes} from "./cards/FontAwesomeButtonEnumTypes";

const EditCardRibbon = ({ enabled = true, disabledMessage, onSave, onCancel, onEdit, isEditing, discrete = true, flatten = false, verticalAlign = false}) => (
    <div className={`edit-card-ribbon ${verticalAlign ? "edit-card-vertical" : ""} ${flatten ? "edit-card-flattened" : ''}`}>
        {isEditing ? (
            <>
                <FontAwesomeButton icon={faCancel} onClick={onCancel} buttonType={!discrete ? new FontAwesomeButtonEnumTypes() : null}/>
                <FontAwesomeButton icon={faFloppyDisk} onClick={onSave} buttonType={!discrete ? new FontAwesomeButtonEnumTypes() : null}/>
            </>
        ) : (
            <>
                <FontAwesomeButton icon={faPencil} onClick={onEdit} buttonType={!discrete ? new FontAwesomeButtonEnumTypes() : null} enabled={enabled} title={!enabled ? disabledMessage : undefined}/>
            </>
        )}
    </div>
)

export default EditCardRibbon;